module.exports = __webpack_public_path__ + "img/low-price.cea864b8.svg";